module.exports = __webpack_public_path__ + "img/fondo_login.a7879849.svg";